import type { ReactNode } from 'react';

/**
 * 分组标签页。
 *
 * 形态照阿里云控制台实测：**浅底容器里放一组标签，选中项白底 + 品牌蓝字**，
 * 不是下划线式。窄屏下容器可横向滚动，选中项会自动滚进视野。
 */
export interface TabItem<T extends string> {
  id: T;
  label: ReactNode;
  badge?: ReactNode;
}

export function TabGroup<T extends string>({
  items,
  active,
  onChange,
  className = '',
}: {
  items: TabItem<T>[];
  active: T;
  onChange: (id: T) => void;
  className?: string;
}) {
  return (
    <div className={`flex gap-1 overflow-x-auto rounded-control bg-nest-2 p-1 ${className}`} role="tablist">
      {items.map((item) => {
        const selected = item.id === active;
        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={(event) => {
              onChange(item.id);
              // 让被选中的标签在窄屏的横滚容器里可见。
              event.currentTarget.scrollIntoView({ block: 'nearest', inline: 'nearest' });
            }}
            className={`flex shrink-0 items-center gap-1.5 rounded-[6px] px-3 py-1.5 text-[13px] font-medium transition-colors ${
              selected ? 'bg-panel text-brand' : 'text-fg-muted hover:text-fg'
            }`}
          >
            {item.label}
            {item.badge}
          </button>
        );
      })}
    </div>
  );
}
